import { createSelector } from '@ngrx/store';
import { UserRole } from '@wtax/data-angular';
import { Config } from 'wtax-config';
import * as fromRoot from '../reducers';

export const selectCanUseMessaging = (config: Config) =>
  createSelector(fromRoot.selectUserProfile, fromRoot.selectUserRole, (user, role: UserRole) => {
    if (!user || !role) {
      return false;
    }

    if (config.messagingDisabledRoles.includes(role)) {
      return false;
    }

    return !!user.messaging;
  });
